import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import * as _ from 'lodash';
import { AbstractControl } from '@angular/forms';
import { LoginService } from '../../../services/login.service';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-reset-response',
  templateUrl: './reset-response.component.html',
  styleUrls: ['../../login.component.scss']
})
export class ResetResponseComponent implements OnInit {
  changePassForm: FormGroup;
  isValid: boolean = false;
  token: string;
  userId: number;
  passwordChanged: boolean = false;
  showPassword = false;
  showConfirmPassword = false;

  constructor(
    private fb: FormBuilder,
    public loginService: LoginService,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    //extracting the token from the URL
    this.token = this.route.snapshot.queryParams.token;
    this.userId = _.parseInt(this.route.snapshot.queryParams.id);

    //initiating the reset password form group
    const passwordCheckRegExp = /^[a-zA-Z0-9](?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&+=|*]).{12,}[a-zA-Z0-9]$/;
    this.changePassForm = this.fb.group({
      password: new FormControl('', [Validators.required, Validators.minLength(2), Validators.pattern(passwordCheckRegExp)]),
      confirmPassword: ['', [Validators.required, Validators.minLength(2)]]
    }, { validators: this.ValidateUrl })
  }
  

  ValidateUrl(control: AbstractControl) {
    let passwordCheck: boolean = false, passwordsMatch: boolean = false,
      password = control.get('password').value,
      confirm_password = control.get('confirmPassword').value;
    if (confirm_password !== password) {
      control.get('password').setErrors({ passwordMismach: true })
    } else {
      control.get('password').setErrors(null)
    }
  }


  changePassword() {
    this.loginService.setNewPassword(this.userId, this.token, this.changePassForm.value.password)
      .subscribe(
        (success) => {
          this.passwordChanged = true;
        },
        (error) => {
          this.passwordChanged = false;
          this.snackBar.open('Unsuccessful password reset, please recheck the password recovery email!', 'close', {
            duration: 4000
          });
        }
      )
  }

}
